import { useState, useEffect } from "react";

interface TocItem {
  id: string;
  label: string;
}

interface TableOfContentsProps {
  items: TocItem[];
}

export default function TableOfContents({ items }: TableOfContentsProps) {
  const [activeId, setActiveId] = useState(items[0]?.id ?? "");

  useEffect(() => {
    const handleScroll = () => {
      const sections = items.map((item) => document.getElementById(item.id));
      const scrollY = window.scrollY + 120;

      for (let i = sections.length - 1; i >= 0; i--) {
        const el = sections[i];
        if (el && el.offsetTop <= scrollY) {
          setActiveId(items[i].id);
          break;
        }
      }
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, [items]);

  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) {
      const top = el.getBoundingClientRect().top + window.scrollY - 90;
      window.scrollTo({ top, behavior: "smooth" });
    }
  };

  return (
    <div className="bg-orange-50 border border-orange-100 rounded-2xl p-5 sticky top-24">
      <div className="flex items-center gap-2 mb-4">
        <div className="w-6 h-6 flex items-center justify-center">
          <i className="ri-list-check-2 text-orange-500 text-base"></i>
        </div>
        <span className="font-bold text-gray-800 text-sm">Neste Artigo</span>
      </div>
      <nav>
        <ol className="space-y-1">
          {items.map((item, idx) => (
            <li key={item.id}>
              <button
                onClick={() => scrollTo(item.id)}
                className={`w-full text-left flex items-center gap-3 px-3 py-2 rounded-lg text-sm transition-all cursor-pointer ${
                  activeId === item.id
                    ? "bg-orange-500 text-white font-semibold"
                    : "text-gray-600 hover:bg-orange-100 hover:text-orange-600"
                }`}
              >
                <span
                  className={`w-5 h-5 flex items-center justify-center rounded-full text-xs font-bold flex-shrink-0 ${
                    activeId === item.id ? "bg-white/20 text-white" : "bg-orange-100 text-orange-500"
                  }`}
                >
                  {idx + 1}
                </span>
                {item.label}
              </button>
            </li>
          ))}
        </ol>
      </nav>
    </div>
  );
}
